import React from 'react';
import { ControlLink } from '@moda/om';
import './EditableSection.scss';

interface Props {
  onChange?: () => void;
  changeLabel?: string;
  children?: React.ReactNode;
  location?: string;
}

export const EditableSection: React.FC<Props> = ({
  changeLabel = 'Change',
  location,
  onChange,
  children
}) => (
  <div className="EditableSection">
    {children}

    {onChange && (
      <ControlLink data-test-id={`editable-section-${changeLabel}-${location}`} onClick={onChange}>
        {changeLabel}
      </ControlLink>
    )}
  </div>
);
